import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import client from "@culturehq/client";
import { ActionButton, DateTimeField, Form, ModalDialog, SubmitButton } from "@culturehq/components";

import { Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import ChqModalDialog from "components/common/ChqModalDialog";

class DuplicateEvent extends Component {
  state = { error: false, open: false, redirect: false };

  componentDidMount() {
    this.componentIsMounted = true;
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleSubmit = async ({ startsAt, endsAt }) => {
    const { event: { id: eventId } } = this.props;
    this.setState({ error: false });

    try {
      const { event } = await client.duplicateEvent({ startsAt, endsAt, eventId });

      if (this.componentIsMounted) {
        this.setState({ open: false, redirect: `/events/${event.id}` });
      }
    } catch (error) {
      if (this.componentIsMounted) {
        this.setState({ error });
      }
    }
  };

  render() {
    const { event } = this.props;
    const { error, open, redirect } = this.state;
    const { startsAt, endsAt } = event;

    if (redirect) {
      return <Redirect to={redirect} />;
    }

    const offset = -new Date().getTimezoneOffset();

    return (
      <>
        <ActionButton icon="copy" onClick={this.handleOpen}>
          <Trans>Duplicate this Event</Trans>
        </ActionButton>
        {open && (
          <ChqModalDialog onClose={this.handleClose}>
            <ModalDialog.Heading onClose={this.handleClose}>
              <Trans>Duplicate this Event</Trans>
            </ModalDialog.Heading>
            <ModalDialog.Body>
              <p><Trans>Create a copy of this event on another date!</Trans></p>

              <Form onSubmit={this.handleSubmit} initialValues={{ startsAt, endsAt }}>
                <DateTimeField name="startsAt" offset={offset} required>
                  <Trans>Event Starts At</Trans>
                </DateTimeField>
                <DateTimeField name="endsAt" offset={offset} required>
                  <Trans>Event Ends At</Trans>
                </DateTimeField>
                <SubmitButton>
                  {submitting => (submitting ? "Loading..." : "Create New Event")}
                </SubmitButton>
              </Form>

              {error && <ErrorMessage error={error} />}
            </ModalDialog.Body>
          </ChqModalDialog>
        )}
      </>
    );
  }
}

export default DuplicateEvent;
